import ScienceIcon from "@mui/icons-material/Science";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AssignmentIcon from "@mui/icons-material/Assignment";

export { C } from "../ipd-billing/constants";

export const NAV_CONFIG = {
  key: "lab",
  base: "",
  title: "Laboratory",
  subtitle: "Tests & examinations",
  icon: ScienceIcon,
  groups: [
    {
      id: "workspace",
      label: "Workspace",
      items: [
        {
          id: "tests",
          label: "Tests & Examinations",
          icon: ScienceIcon,
          path: "/laboratories",
        },
        {
          id: "requisition",
          label: "Order Requisition Print",
          icon: AssignmentIcon,
          path: "/laboratories/requisition",
        },
      ],
    },
  ],
  footer: [
    {
      id: "go-home",
      label: "IPD Home",
      icon: LocalHospitalIcon,
      href: "/main-landing",
    },
  ],
};
